import { useSession } from '#pplx/frontend/auth/useSession.js';
export const useIsOrgAdmin = () => {
    const { session } = useSession();
    const orgRole = session?.user?.org_role;
    return orgRole === 'ADMIN';
};
//# sourceMappingURL=useIsOrgAdmin.js.map